// import { useState } from "react"
// import Header from "../components/Header"
// import Footer from "../components/Footer"
// import { Button } from "../components/Button"
// import '../pages/ContactPage.css';

// export default function ContactPage() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     subject: "",
//     message: "",
//   })
//   const [submitted, setSubmitted] = useState(false)

//   const handleChange = (e) => {
//     const { name, value } = e.target
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }))
//   }

//   const handleSubmit = (e) => {
//     e.preventDefault()
//     if (formData.name && formData.email && formData.subject && formData.message) {
//       setSubmitted(true)
//       setFormData({ name: "", email: "", subject: "", message: "" })
//       setTimeout(() => setSubmitted(false), 3000)
//     }
//   }

//   return (
//     <main className="contact-main">
//       <Header />

//       <section className="contact-hero-section">
//         <div className="contact-container">
//           <div className="contact-header">
//             <h1 className="contact-title">Contact Us</h1>
//             <p className="contact-subtitle">Get in touch with our team</p>
//           </div>

//           <div className="contact-grid">
//             <div className="contact-info-section">
//               <div>
//                 <h3 className="contact-section-title">Contact Information</h3>
//                 <div className="contact-details-list">
//                   <div>
//                     <p className="contact-detail-label">Address</p>
//                     <p className="contact-detail-value">A-1/12S/F Flat no-c-2,<br />KH No-1642/1,773/2,774/2,Arya Nagar, New Delhi -110047</p>
//                   </div>
//                   <div>
//                     <p className="contact-detail-label">Phone</p>
//                     <p className="contact-detail-value">9431927355 / 9771491381</p>
//                   </div>
//                   <div>
//                     <p className="contact-detail-label">Email</p>
//                     <p className="contact-detail-value">info@natoshine.com</p>
//                   </div>
//                   <div>
//                     <p className="contact-detail-label">Business Hours</p>
//                     <p className="contact-detail-value">Monday - Friday: 9:00 AM - 6:00 PM</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="contact-form-card">
//               <h3 className="contact-section-title" style={{ marginBottom: '1.5rem' }}>Send us a Message</h3>

//               {submitted && (
//                 <div className="contact-success-msg">
//                   Thank you! Your message has been sent successfully.
//                 </div>
//               )}

//               <form onSubmit={handleSubmit} className="contact-form">
//                 <div className="form-group">
//                   <label className="form-label">Name</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="form-input"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label">Email</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     className="form-input"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label">Subject</label>
//                   <input
//                     type="text"
//                     name="subject"
//                     value={formData.subject}
//                     onChange={handleChange}
//                     className="form-input"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label">Message</label>
//                   <textarea
//                     name="message"
//                     value={formData.message}
//                     onChange={handleChange}
//                     rows="4"
//                     className="form-textarea"
//                     required
//                   />
//                 </div>
//                 <Button type="submit" className="form-submit-btn">
//                   Send Message
//                 </Button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </main>
//   )
// }

import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Button } from "../components/Button";
import emailjs from "emailjs-com";
import "./ContactPage.css";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email) return;

    setLoading(true);
    setError("");

    emailjs
      .send(
        "service_xr7bo8m",
        "template_contact_us",
        {
          name: formData.name,
          email: formData.email,
          subject: formData.subject || "No subject provided",
          message: formData.message || "No message provided",
        },
        "8iEceYjRhfGZ0Bb0J"
      )
      .then(() => {
        setSubmitted(true);
        setFormData({ name: "", email: "", subject: "", message: "" });
        setLoading(false);
        setTimeout(() => setSubmitted(false), 3000);
      })
      .catch(() => {
        setError("Failed to send message. Please try again.");
        setLoading(false);
      });
  };

  return (
    <main className="contact-main">
      <Header />

      <section className="contact-hero-section">
        <div className="contact-container">
          <div className="contact-header">
            <h1 className="contact-title">Contact Us</h1>
            <p className="contact-subtitle">Get in touch with our team</p>
          </div>

          <div className="contact-grid">
            <div className="contact-info-section">
              <h3 className="contact-section-title">Contact Information</h3>
              <div className="contact-details-list">
                <div>
                  <p className="contact-detail-label">Address</p>
                  <p className="contact-detail-value">
                    A-1/12 S/F Plat No-C-2,<br />Kh No -1642/1,773/2,774/2, Aya Nagar, New Delhi -110047
                  </p>
                </div>
                <div>
                  <p className="contact-detail-label">Phone</p>
                  <p className="contact-detail-value">9431927355</p>
                </div>
                <div>
                  <p className="contact-detail-label">Email</p>
                  <p className="contact-detail-value">info@natoshine.com</p>
                </div>
                <div>
                  <p className="contact-detail-label">Business Hours</p>
                  <p className="contact-detail-value">
                    24*7
                  </p>
                </div>
              </div>
            </div>

            <div className="contact-form-card">
              <h3
                className="contact-section-title"
                style={{ marginBottom: "1.5rem" }}
              >
                Send us a Message
              </h3>

              {submitted && (
                <div className="contact-success-msg">
                  Thank you! Your message has been sent successfully.
                </div>
              )}

              {error && <div className="contact-error-msg">{error}</div>}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Subject</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-textarea"
                    rows="4"
                  ></textarea>
                </div>

                <Button
                  type="submit"
                  className="form-submit-btn"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Message"}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
